import { PapiDeviation } from '@wix/da-papi-types';
import { dollarsToPoints } from '@wix/da-shared-react/pkg/utils/points';
import { DeviationSubmitFormData } from '@wix/da-submit-shared/pkg/redux/types';

// Prepare the form data to be sent to the server
export const submitAdapter = (
  deviation: PapiDeviation,
  downloadDollarPrice: number
): DeviationSubmitFormData => {
  return {
    deviationId: deviation.deviationId,
    pcp_price_points: dollarsToPoints(downloadDollarPrice),
  };
};
